// extracted by mini-css-extract-plugin
module.exports = {"work-steps-section":"WorkStepsSection_work-steps-section__wOyuH","tiles":"WorkStepsSection_tiles__I5y2H","tiles-item":"WorkStepsSection_tiles-item__u9qz6"};